import Header from "../../components/header";
import { Row, Col, Card, Button, Pagination } from "react-bootstrap";
import { useState, useEffect, useRef, useMemo } from "react";
import "./index.css";
import { useNavigate, useLocation } from "react-router-dom";
import dayjs from "dayjs";
import {
  getCategory,
  getState,
  getCityByStateId,
  getVenueByCityId,getSearchEvent,
  getAppSettings,
  getEventById,
  getFeaturedEvent,
  getPreviewEventByToken,
} from "../../api/api";
import { Swiper, SwiperSlide } from "swiper/react";
import { createPortal } from "react-dom";
import { Navigation, Pagination as PaginationSwiper } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Carousel, DatePicker, Slider } from "antd";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AOS from "aos";
import "aos/dist/aos.css";
import Calendar  from "../../assets/image/calendario 1.svg";
import calendarioBlanco from "../../assets/image/calendario 2.svg";
import ubi  from "../../assets/image/ubicacion 1.svg";
import ubiBlanco  from "../../assets/image/ubicacion 2.svg";
import cherow from "../../assets/image/flecha-hacia-abajo-para-navegar 1.svg";
import dolar from "../../assets/image/dolar 1.svg";
import card from "../../assets/image/tarjeta-de-credito 1.svg";
import wallet from "../../assets/image/billetera 1.svg";
import visa from "../../assets/image/Cards/campanas copia 12.svg";
import maestro from "../../assets/image/Cards/Maestro_2016.svg copia.svg";
import mastercard from "../../assets/image/Cards/Mastercard-logo.svg copia.svg";
import american from "../../assets/image/Cards/campanas copia 1.svg";
import argencard from "../../assets/image/Cards/b69b09bc-00db-435c-b79b-fe88d15c121d 1.svg";
import dinners from "../../assets/image/Cards/logo-Diners-Club-International copia.svg";
import cabal from "../../assets/image/Cards/campanas copia 2.svg";
import mp from "../../assets/image/wallets/campanas copia 1.svg";
import bna from "../../assets/image/wallets/campanas copia 2.svg";
import uala from "../../assets/image/wallets/campanas copia 3.svg";
import claropay from "../../assets/image/wallets/campanas copia 4.svg";
import modo from "../../assets/image/wallets/campanas copia 5.svg";
import naranja from "../../assets/image/wallets/campanas copia 6.svg";
import personal from "../../assets/image/wallets/campanas copia 7.svg";
import cuentaDni from "../../assets/image/wallets/campanas copia 8.svg";
import cruze from "../../assets/image/flecha-hacia-abajo-para-navegar 8.svg";
import not from "../../assets/image/archivo 1.svg";
import campana from "../../assets/image/campana-de-notificacion 1.svg";
import SpinLoading from "../../components/spinLoading/SpinLoading";
import FloatingAppButton from "../../components/FloatingAppButton";
import { useMediaQuery } from "react-responsive";
import { handleError } from "../../helpers/handleError";
import { getPreviewTokenFromSearch, getStoredPreviewToken, setPreviewBlockedMessage } from "../../helpers/preview";
import { loadMetaPixel, trackMetaPixel } from "../../helpers/metaPixel";

const HERO_FALLBACK_POSTER =
  "https://zoco-ticket-images.s3.us-east-2.amazonaws.com/Videos-landing/video-herolanding.png";
const HERO_FALLBACK_VIDEOS = [
  "https://zoco-ticket-images.s3.us-east-2.amazonaws.com/Videos/hero+pc+corregido.mp4",
  "https://zoco-ticket-images.s3.us-east-2.amazonaws.com/Videos/video+intro1.mp4",
  "https://zoco-ticket-images.s3.us-east-2.amazonaws.com/Videos/intro2.mp4",
  "https://zoco-ticket-images.s3.us-east-2.amazonaws.com/Videos/intro+3.mp4",
];
// Videos habilitados en hero mobile y desktop.
const HERO_MOBILE_VIDEOS_ENABLED = true;
const HERO_DESKTOP_VIDEOS_ENABLED = true;

const normalizeHomeOrder = (value) => {
  const numeric = Number(value);
  if (!Number.isFinite(numeric) || numeric < 1) return null;
  return Math.trunc(numeric);
};

const sortEventsForHome = (list = []) =>
  (Array.isArray(list) ? list : [])
    .map((item, index) => ({
      item,
      index,
      homeOrder: normalizeHomeOrder(item?.homeOrder),
    }))
    .sort((a, b) => {
      const aHasOrder = a.homeOrder !== null;
      const bHasOrder = b.homeOrder !== null;
      if (aHasOrder && bHasOrder && a.homeOrder !== b.homeOrder) {
        return a.homeOrder - b.homeOrder;
      }
      if (aHasOrder !== bHasOrder) {
        return aHasOrder ? -1 : 1;
      }
      return a.index - b.index;
    })
    .map(({ item }) => item);

const toBooleanFlag = (value) => {
  if (typeof value === "boolean") return value;
  if (typeof value === "number") return value === 1;
  if (typeof value === "string") {
    const normalized = value.trim().toLowerCase();
    return ["true", "1", "yes", "si", "sí"].includes(normalized);
  }
  return false;
};

const readHideMobileHeroText = (eventItem) =>
  [
    eventItem?.hideMobileHeroText,
    eventItem?.hideMobileTitleDescription,
    eventItem?.hideTitleDescriptionOnMobile,
    eventItem?.hideTitleAndDescriptionOnMobile,
  ].some((value) => toBooleanFlag(value));

// Reusable pills must be top-level to preserve state across re-renders
const PillDropdown = ({ widthClass = "", iconSrc, value, options = [], onChange, placeholder = "Seleccionar", searchable = false }) => {
  const [open, setOpen] = useState(false);
  const [query, setQuery] = useState("");
  const ref = useRef(null);
  const menuRef = useRef(null);
  const [menuPos, setMenuPos] = useState(null);

  useEffect(() => {
    const onDocClick = (e) => {
      if (!ref.current) return;
      // Cerrar solo si el click es fuera del trigger y del menÃº (incluido el portal)
      const clickedInsideTrigger = ref.current.contains(e.target);
      const clickedInsideMenu = menuRef.current && menuRef.current.contains(e.target);
      if (!clickedInsideTrigger && !clickedInsideMenu) setOpen(false);
    };
    document.addEventListener("mousedown", onDocClick);
    return () => document.removeEventListener("mousedown", onDocClick);
  }, []);

  const recalcMenuPos = () => {
    try {
      if (!ref.current) return;
      const r = ref.current.getBoundingClientRect();
      const vw = window.innerWidth || document.documentElement.clientWidth;
      const width = Math.min(320, vw - 28);
      const idealLeft = r.left + r.width / 2 - width / 2; // centrar relativo a viewport
      const left = Math.max(14, Math.min(vw - width - 14, idealLeft));
      const top = r.bottom + 10;
      setMenuPos({ left, top, width });
    } catch (_) {}
  };

  useEffect(() => {
    if (open && (typeof window !== 'undefined') && window.innerWidth <= 430) {
      recalcMenuPos();
      const onScroll = () => recalcMenuPos();
      const onResize = () => recalcMenuPos();
      window.addEventListener('scroll', onScroll, true);
      window.addEventListener('resize', onResize);
      return () => { window.removeEventListener('scroll', onScroll, true); window.removeEventListener('resize', onResize); };
    }
  }, [open]);

  const current = options.find((o) => String(o.value) === String(value));
  const label = current ? current.label : (placeholder || options[0]?.label || "Seleccionar");
  const filtered = !searchable || !query
    ? options
    : options.filter(o => String(o.label).toLowerCase().includes(query.toLowerCase()));

  return (
    <div ref={ref} className={`pill-select ${widthClass} ${open ? 'open' : ''}`}>
      {iconSrc && <img src={iconSrc} alt="ico" className="icon" />}
      <button type="button" className="pill-trigger" onClick={() => setOpen(v=>!v)}>{label}</button>
      <img className="arrow" src={cherow} alt="abrir" />
      {open && ((typeof window !== 'undefined' && window.innerWidth <= 430)
        ? createPortal(
          <div ref={menuRef} className="pill-menu" role="listbox" style={{ position: 'fixed', left: menuPos?.left ?? 16, top: menuPos?.top ?? 80, width: menuPos?.width ?? Math.min(320, (typeof window!=='undefined'?window.innerWidth:320) - 28), right: 'auto' }}>
            {searchable && (
              <div className="pill-menu-search">
                <input type="text" placeholder="Buscar..." value={query} onChange={(e)=> setQuery(e.target.value)} />
              </div>
            )}
            {filtered.map((opt) => (
              <button
                type="button"
                key={String(opt.value)}
                className={`pill-menu-item ${String(opt.value) === String(value) ? 'active' : ''}`}
                onClick={() => { setOpen(false); onChange && onChange(opt.value, opt); setQuery(""); }}
                role="option"
                aria-selected={String(opt.value) === String(value)}
              >
                {opt.label}
              </button>
            ))}
          </div>,
          document.body
        )
        : (
          <div ref={menuRef} className="pill-menu" role="listbox" onClick={(e) => e.stopPropagation()}>
          {searchable && (
            <div className="pill-menu-search">
              <input type="text" placeholder="Buscar..." value={query} onChange={(e)=> setQuery(e.target.value)} />
            </div>
          )}
          {filtered.map((opt) => (
            <button
              type="button"
              key={String(opt.value)}
              className={`pill-menu-item ${String(opt.value) === String(value) ? 'active' : ''}`}
              onClick={() => { setOpen(false); onChange && onChange(opt.value, opt); setQuery(""); }}
              role="option"
              aria-selected={String(opt.value) === String(value)}
            >
              {opt.label}
            </button>
          ))}
          </div>
        )
      )}
    </div>
  );
};

const DateFilterPill = ({ widthClass = "w-300", rangeValue, dayValue, onApply }) => {
  const normalizeRange = (vals) => {
    if (!Array.isArray(vals)) return null;
    const start = vals[0] ? (dayjs.isDayjs(vals[0]) ? vals[0].clone() : dayjs(vals[0])) : null;
    const end = vals[1] ? (dayjs.isDayjs(vals[1]) ? vals[1].clone() : dayjs(vals[1])) : null;
    if (!start && !end) return null;
    if (start && end && end.isBefore(start)) return [end, start];
    return [start, end];
  };

  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const menuRef = useRef(null);
  const [menuPos, setMenuPos] = useState(null);
  const [tempRange, setTempRange] = useState(() => normalizeRange(rangeValue));
  const [tempDay, setTempDay] = useState(() => (dayValue ? dayjs(dayValue) : null));

  useEffect(() => {
    setTempRange(normalizeRange(rangeValue));
    setTempDay(dayValue ? dayjs(dayValue) : null);
  }, [rangeValue, dayValue]);

  const updateTempSelection = (vals) => {
    if (!Array.isArray(vals)) {
      setTempRange(null);
      setTempDay(null);
      return;
    }
    const rawStart = vals[0];
    const rawEnd = vals[1];
    const start = rawStart ? (dayjs.isDayjs(rawStart) ? rawStart : dayjs(rawStart)) : null;
    const end = rawEnd ? (dayjs.isDayjs(rawEnd) ? rawEnd : dayjs(rawEnd)) : null;
    if (start && end) {
      const ordered = !end.isBefore(start) ? [start.clone(), end.clone()] : [end.clone(), start.clone()];
      setTempRange(ordered);
      setTempDay(null);
    } else if (start) {
      setTempDay(start.clone());
      setTempRange(null);
    } else if (end) {
      setTempDay(end.clone());
      setTempRange(null);
    } else {
      setTempRange(null);
      setTempDay(null);
    }
  };

  const fmt = (d) => dayjs(d).format('DD MMM');
  const label = (() => {
    if (rangeValue && rangeValue[0] && rangeValue[1]) {
      const [a,b] = rangeValue; const same = a && b && dayjs(a).isSame(b,'day');
      return same ? `Fecha: ${fmt(a)}` : `Fecha: ${fmt(a)} - ${fmt(b)}`;
    }
    if (dayValue) return `Fecha: ${fmt(dayValue)}`;
    return 'Fecha';
  })();

  const recalcMenuPos = () => {
    try {
      if (!ref.current) return;
      const r = ref.current.getBoundingClientRect();
      const vw = window.innerWidth || document.documentElement.clientWidth;
      const width = Math.min(360, vw - 28);
      const idealLeft = r.left + r.width / 2 - width / 2; // centrado relativo al viewport
      const left = Math.max(14, Math.min(vw - width - 14, idealLeft));
      const top = r.bottom + 10;
      setMenuPos({ left, top, width });
    } catch (_) {}
  };

  useEffect(() => {
    if (open && (typeof window !== 'undefined') && window.innerWidth <= 430) {
      recalcMenuPos();
      const onScroll = () => recalcMenuPos();
      const onResize = () => recalcMenuPos();
      window.addEventListener('scroll', onScroll, true);
      window.addEventListener('resize', onResize);
      return () => { window.removeEventListener('scroll', onScroll, true); window.removeEventListener('resize', onResize); };
    }
  }, [open]);

  const applyAndClose = () => {
    const [start, end] = tempRange || [];
    if (start && end) {
      onApply && onApply({ range: normalizeRange([start, end]), day: null });
    } else {
      onApply && onApply({ range: null, day: tempDay ? dayjs(tempDay) : null });
    }
    setOpen(false);
  };

  const setQuickToday = () => {
    const today = dayjs();
    setTempDay(today);
    setTempRange(null);
  };
  const setQuickTomorrow = () => {
    const tomorrow = dayjs().add(1, 'day');
    setTempDay(tomorrow);
    setTempRange(null);
  };
  const setQuickThisWeek = () => {
    try {
      const start = dayjs();
      const dow = start.day(); // 0..6 (domingo..sabado)
      const end = start.clone().add(Math.max(0, 6 - dow), 'day'); // hasta sabado
      setTempRange(normalizeRange([start, end]));
      setTempDay(null);
    } catch(_) {
      const startFallback = dayjs();
      setTempRange(normalizeRange([startFallback, startFallback.clone().add(6, 'day')]));
      setTempDay(null);
    }
  };

  const isMobile = (typeof window !== 'undefined') && window.innerWidth <= 430;

  const menuInner = (
    <div
      ref={menuRef}
      className="pill-menu pill-menu-date"
      role="dialog"
      onClick={(e)=> e.stopPropagation()}
      style={isMobile ? { position: 'static', top: 'auto', left: 'auto', right: 'auto', width: '100%' } : undefined}
    >
      <div style={{ padding: 12 }}>
        <div style={{ fontWeight: 700, marginBottom: 8, color: '#2D3035' }}>Elegir fecha</div>

        {/* Quick chips (Hoy / Manana / Esta semana) */}
        <div className="pill-quick-row" aria-label="Rapidos de fecha">
          <button type="button" className="pill-quick" onClick={setQuickToday}>Hoy</button>
          <button type="button" className="pill-quick" onClick={setQuickTomorrow}>Mañana</button>
          <button type="button" className="pill-quick" onClick={setQuickThisWeek}>Esta semana</button>
        </div>

          <div style={{ display: 'grid', gap: 12 }}>
            <DatePicker.RangePicker
            value={
              Array.isArray(tempRange) && tempRange[0] && tempRange[1]
                ? tempRange
                : tempDay
                  ? [tempDay, tempDay]
                  : null
            }
              onChange={(vals) => updateTempSelection(vals)}
              onCalendarChange={(vals) => updateTempSelection(vals)}
            style={{ width: '100%' }}
            getPopupContainer={() => menuRef.current || ref.current || document.body}
            open={true}
            onOpenChange={() => {}}
            dropdownClassName="pill-inline-range"
          />
          <div className="pill-menu-actions">
            <button type="button" className="pill-action secondary" onClick={() => { setTempDay(null); setTempRange(null); }}>Limpiar</button>
            <div style={{ flex: 1 }} />
            <button type="button" className="pill-action secondary" onClick={() => setOpen(false)}>Cerrar</button>
            <button type="button" className="pill-action primary" onClick={applyAndClose}>Aplicar</button>
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <div ref={ref} className={`pill-select ${widthClass} ${open ? 'open' : ''}`}>
      <img className="icon" src={Calendar} alt="calendario" style={{width: 17, height: 17}} />
      <button type="button" className="pill-trigger" onClick={() => setOpen(v=>!v)}>{label}</button>
      <img className="arrow" src={cherow} alt="abrir" />
      {open && (
        isMobile
          ? createPortal(
              <div style={{ position: 'fixed', left: menuPos?.left ?? 16, top: menuPos?.top ?? 80, width: menuPos?.width ?? Math.min(320, (typeof window!=='undefined'?window.innerWidth:320) - 28), right: 'auto', zIndex: 10000, pointerEvents: 'auto' }}>
                {menuInner}
              </div>,
              document.body
            )
          : menuInner
      )}
    </div>
  );
};

const PriceRangePill = ({ widthClass = "w-260", value, onApply }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const menuRef = useRef(null);
  const [temp, setTemp] = useState(value || null);
  const [menuPos, setMenuPos] = useState(null);
  useEffect(() => { setTemp(value || null); }, [value]);
  const display = (!value || !Array.isArray(value) || value.length < 2)
    ? 'Precio'
    : `Precio: ${value[0].toLocaleString()} - ${value[1].toLocaleString()}`;
  const maxPrice = 200000;

  const recalcMenuPos = () => {
    try {
      if (!ref.current) return;
      const r = ref.current.getBoundingClientRect();
      const vw = window.innerWidth || document.documentElement.clientWidth;
      const width = Math.min(320, vw - 28);
      const idealLeft = r.left + r.width / 2 - width / 2;
      const left = Math.max(14, Math.min(vw - width - 14, idealLeft));
      const top = r.bottom + 10;
      setMenuPos({ left, top, width });
    } catch (_) {}
  };

  useEffect(() => {
    if (open && (typeof window !== 'undefined') && window.innerWidth <= 430) {
      recalcMenuPos();
      const onScroll = () => recalcMenuPos();
      const onResize = () => recalcMenuPos();
      window.addEventListener('scroll', onScroll, true);
      window.addEventListener('resize', onResize);
      return () => { window.removeEventListener('scroll', onScroll, true); window.removeEventListener('resize', onResize); };
    }
  }, [open]);
  return (
    <div ref={ref} className={`pill-select ${widthClass} ${open ? 'open' : ''}`}>
      <img className="icon" src={dolar} alt="precio" style={{width: 17, height: 17}} />
      <button type="button" className="pill-trigger" onClick={() => setOpen(v=>!v)}>{display}</button>
      <img className="arrow" src={cherow} alt="abrir" />
      {open && ((typeof window !== 'undefined' && window.innerWidth <= 430)
        ? createPortal(
            <div ref={menuRef} className="pill-menu" role="dialog" style={{ position: 'fixed', left: menuPos?.left ?? 16, top: menuPos?.top ?? 80, width: menuPos?.width ?? Math.min(320, (typeof window!=='undefined'?window.innerWidth:320) - 28), right: 'auto' }}>
              <div style={{ padding: 12 }}>
                <div style={{ fontWeight: 700, marginBottom: 8, color: '#2D3035' }}>Rango de precio</div>
                <Slider range min={0} max={maxPrice} step={1000} value={temp || [0, maxPrice]} onChange={(vals)=> setTemp(vals)} marks={{ 0: '0', 10000: '10k', 50000: '50k', 100000: '100k', [maxPrice]: `${(maxPrice/1000).toFixed(0)}k+` }} />
                <div className="pill-menu-actions">
                  <button type="button" className="pill-action secondary" onClick={() => setTemp(null)}>Limpiar</button>
                  <div style={{ flex: 1 }} />
                  <button type="button" className="pill-action secondary" onClick={() => setOpen(false)}>Cerrar</button>
                  <button type="button" className="pill-action primary" onClick={() => { onApply && onApply(temp); setOpen(false); }}>Aplicar</button>
                </div>
              </div>
            </div>,
            document.body
          )
        : (
          <div ref={menuRef} className="pill-menu" role="dialog" onClick={(e)=> e.stopPropagation()}>
            <div style={{ padding: 12 }}>
              <div style={{ fontWeight: 700, marginBottom: 8, color: '#2D3035' }}>Rango de precio</div>
              <Slider range min={0} max={maxPrice} step={1000} value={temp || [0, maxPrice]} onChange={(vals)=> setTemp(vals)} marks={{ 0: '0', 10000: '10k', 50000: '50k', 100000: '100k', [maxPrice]: `${(maxPrice/1000).toFixed(0)}k+` }} />
              <div className="pill-menu-actions">
                <button type="button" className="pill-action secondary" onClick={() => setTemp(null)}>Limpiar</button>
                <div style={{ flex: 1 }} />
                <button type="button" className="pill-action secondary" onClick={() => setOpen(false)}>Cerrar</button>
                <button type="button" className="pill-action primary" onClick={() => { onApply && onApply(temp); setOpen(false); }}>Aplicar</button>
              </div>
            </div>
          </div>
        )
      )}
    </div>
  );
};

const Event = () => {
  const [appSettings, setAppSettings] = useState({});
  // Mostrar al menos esta cantidad de eventos antes de "Ver más"
  const INITIAL_EVENTS_MIN = 9;
  const [category, setCategory] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedCategories, setSelectedCategories] = useState([]); // multi-selecciÃ³n
  const [city, setCity] = useState([]);
  const [selectedCity, setSelectedCity] = useState("");
  const [state, setState] = useState([]);
  const [selectedState, setSelectedState] = useState("");
  const [venues, setVenues] = useState([]);
  const [selectedVenue, setSelectedVenue] = useState("");
  const defaultDateFilter = "Upcoming Events";
  const navigate = useNavigate();
  const location = useLocation();
  const previewToken = useMemo(
    () => getPreviewTokenFromSearch(location.search) || getStoredPreviewToken(),
    [location.search]
  );
  const isPreview = Boolean(previewToken);
  const pageLoadKey = useMemo(() => {
    try {
      if (typeof performance !== "undefined") {
        if (performance.timeOrigin) return String(performance.timeOrigin);
        const navStart = performance?.timing?.navigationStart;
        if (navStart) return String(navStart);
        const entries = performance.getEntriesByType("navigation");
        if (entries && entries[0] && typeof entries[0].startTime === "number") {
          return String(entries[0].startTime);
        }
      }
    } catch (_) {}
    return String(Date.now());
  }, []);
  const [event, setEvent] = useState([]);
  // Hero destacado (carrusel superior)
  const [featuredEvents, setFeaturedEvents] = useState([]);
  const [activeHeroIndex, setActiveHeroIndex] = useState(0);
  const [activeMobileHeroIndex, setActiveMobileHeroIndex] = useState(0);
  const [mobileHeroVideoDelayDone, setMobileHeroVideoDelayDone] = useState(false);
  const mobileHeroSwiperRef = useRef(null);
  const desktopHeroRef = useRef(null);
  const desktopHeroCarouselRef = useRef(null);
  const desktopHeroAdvanceTimerRef = useRef(null);
  const MOBILE_HERO_VIDEO_DELAY_MS = 2000;
  const DESKTOP_HERO_IMAGE_DURATION_MS = 500;

  // Mobile formatting: show only venue + city (omit state)
  const formatVenueCity = (full = "") => {
    try {
      const parts = String(full)
        .split(",")
        .map((s) => s && s.trim())
        .filter(Boolean);
      if (parts.length >= 2) return `${parts[0]}, ${parts[1]}`;
      return parts.join(", ");
    } catch (_) {
      return String(full || "");
    }
  };
  const resolvePreviewBlockMessage = (err) => {
    const status = err?.response?.status;
    const message = String(err?.response?.data?.message || "");
    if (!status) return "";
    if ([403, 410, 429].includes(status)) {
      return message || "Vista previa no disponible";
    }
    if (status === 404) {
      const lower = message.toLowerCase();
      if (lower.includes("link") || lower.includes("no encontrado") || lower.includes("no disponible")) {
        return message || "Vista previa no disponible";
      }
      return "";
    }
    return "";
  };
  useEffect(() => {
    if (!isPreview || !previewToken) return;
    const storageKey = `preview_home_load_${previewToken}`;
    let shouldCount = true;
    try {
      const lastKey = sessionStorage.getItem(storageKey);
      if (lastKey && lastKey === pageLoadKey) shouldCount = false;
    } catch (_) {}
    if (!shouldCount) return;
    try {
      sessionStorage.setItem(storageKey, pageLoadKey);
    } catch (_) {}
    getPreviewEventByToken(previewToken)
      .then(() => {})
      .catch((err) => {
        const message = resolvePreviewBlockMessage(err);
        if (message) setPreviewBlockedMessage(message);
      });
  }, [isPreview, previewToken, pageLoadKey]);

  const renderCategoryIcon = (name = "") => {
    const n = String(name).toLowerCase();
    if (/(deporte)/.test(n)) {
      return (
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="12" cy="12" r="9" stroke="#8F99A2" strokeWidth="2"/>
          <path d="M3 12h18M12 3c3 4 3 14 0 18M5 5c5 2 9 2 14 0M5 19c5-2 9-2 14 0" stroke="#8F99A2" strokeWidth="2" strokeLinecap="round"/>
        </svg>
      );
    }
    if (/(cine|movie|film)/.test(n)) {
      return (
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="3" y="7" width="18" height="10" rx="2" stroke="#8F99A2" strokeWidth="2"/>
          <path d="M7 7V5M11 7V5M15 7V5M19 7V5" stroke="#8F99A2" strokeWidth="2" strokeLinecap="round"/>
        </svg>
      );
    }
    if (/(festival|fiesta|dj)/.test(n)) {
      return (
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M9 18a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z" stroke="#8F99A2" strokeWidth="2"/>
          <path d="M9 12V4l10-2v8" stroke="#8F99A2" strokeWidth="2" strokeLinecap="round"/>
        </svg>
      );
    }
    if (/(teatro|theat|obra|mascara|mask)/.test(n)) {
      return (
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M3 4v6c0 4 4 6 9 6s9-2 9-6V4" stroke="#8F99A2" strokeWidth="2"/>
          <path d="M7 10s1-1 2-1 2 1 2 1M13 10s1-1 2-1 2 1 2 1" stroke="#8F99A2" strokeWidth="2" strokeLinecap="round"/>
        </svg>
      );
    }
    if (/(comedia|comedy)/.test(n)) {
      return (
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="12" cy="12" r="9" stroke="#8F99A2" strokeWidth="2"/>
          <path d="M8 10h.01M16 10h.01M8 15c1.5-1 6.5-1 8 0" stroke="#8F99A2" strokeWidth="2" strokeLinecap="round"/>
        </svg>
      );
    }
    if (/(arte|art)/.test(n)) {
      return (
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="4" y="5" width="14" height="10" rx="2" stroke="#8F99A2" strokeWidth="2"/>
          <path d="M6 19h12M12 15v4" stroke="#8F99A2" strokeWidth="2" strokeLinecap="round"/>
        </svg>
      );
    }
    if (/(concierto|concert|musica|music)/.test(n)) {
      return (
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M9 19a3 3 0 1 0 0-6 3 3 0 0 0 0 6ZM15 16V5l6-2v6" stroke="#8F99A2" strokeWidth="2" strokeLinecap="round"/>
        </svg>
      );
    }
    // genÃ©rico
    return (
      <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="5" y="5" width="14" height="14" rx="3" stroke="#8F99A2" strokeWidth="2"/>
      </svg>
    );
  };
  const [pagination, setPagination] = useState({
    currentPage: 1,
    totalPages: 0,
  });
  const [minPrices, setMinPrices] = useState({}); // { [eventId]: number }
  const [isLoading, setIsLoading] = useState(false)
  const [selectedFilter, setSelectedFilter] = useState("Upcoming Events");
  // Filtros visuales
  const [priceRangeValues, setPriceRangeValues] = useState(null); // [min,max] | null
  const [dateSelected, setDateSelected] = useState(null); // dayjs | null (modo dÃ­a)
  const [dateRangeValues, setDateRangeValues] = useState(null); // [dayjs, dayjs] | null (modo rango)
  const swipereventRef = useRef(null);
  const categorySwiperRef = useRef(null);
  const eventsTopRef = useRef(null);
  const filtersStickyRef = useRef(null);
  const pendingMobileScrollRef = useRef(false);
  const isMobile = useMediaQuery({ maxWidth: 767 });
  const isTablet = useMediaQuery({ maxWidth: 900 });
  const isLarge = useMediaQuery({ maxWidth: 1200 });
  const isDesktop = useMediaQuery({ maxWidth: 1400 });
  const maxVisiblePages = isMobile ? 1 : isTablet ? 3 : isLarge ? 5 : isDesktop ? 7 : 11;
  const listEagerCount = isMobile ? 2 : 3;
  const heroImgLoading = (index) => (index === 0 ? "eager" : "lazy");
  const heroImgPriority = (index) => (index === 0 ? "high" : "auto");
  const normalizeVideoList = (value) => {
    if (!value) return [];
    if (Array.isArray(value)) {
      return value.map((item) => String(item || "").trim()).filter(Boolean);
    }
    if (typeof value === "string") {
      const trimmed = value.trim();
      return trimmed ? [trimmed] : [];
    }
    return [];
  };

  useEffect(() => {
    setMobileHeroVideoDelayDone(false);
    const t = setTimeout(() => setMobileHeroVideoDelayDone(true), MOBILE_HERO_VIDEO_DELAY_MS);
    return () => clearTimeout(t);
  }, [activeMobileHeroIndex]);

  useEffect(() => {
    if (!HERO_MOBILE_VIDEOS_ENABLED) return;
    const swiper = mobileHeroSwiperRef.current;
    if (!swiper?.el) return;
    try {
      const videos = swiper.el.querySelectorAll(".mobile-slide-video") || [];
      videos.forEach((video) => {
        const slideIndex = Number(video.dataset.slideIndex);
        if (slideIndex === activeMobileHeroIndex && mobileHeroVideoDelayDone) {
          video.play().catch(() => {});
        } else {
          video.pause();
          try {
            video.currentTime = 0;
          } catch (_) {}
        }
      });
    } catch (_) {}
  }, [activeMobileHeroIndex, mobileHeroVideoDelayDone]);

  useEffect(() => {
    if (!HERO_DESKTOP_VIDEOS_ENABLED) return;
    const root = desktopHeroRef.current;
    if (!root) return;
    try {
      const videos = root.querySelectorAll(".event-hero-video") || [];
      videos.forEach((video) => {
        const slideIndex = Number(video.dataset.slideIndex);
        const slideEl = video.closest(".slick-slide");
        const isVisibleSlide = Boolean(slideEl && slideEl.classList.contains("slick-active"));
        const shouldPlay = !isMobile && slideIndex === activeHeroIndex && isVisibleSlide;
        if (shouldPlay) {
          video.play().catch(() => {});
        } else {
          video.pause();
          try {
            video.currentTime = 0;
          } catch (_) {}
        }
      });
    } catch (_) {}
  }, [activeHeroIndex, featuredEvents.length, isMobile]);
  const listImgLoading = (index) => (index < listEagerCount ? "eager" : "lazy");
  const listImgPriority = (index) => (index === 0 ? "high" : "auto");
  const arteIndex = useMemo(() => {
    const list = Array.isArray(category) ? category : [];
    const idx = list.findIndex((c) => String(c?.name || '').toLowerCase().startsWith('arte'));
    return idx >= 0 ? idx : 0;
  }, [category]);

  // En móvil: reordenar categorías poniendo primero las seleccionadas
  const categoryOrdered = useMemo(() => {
    const list = Array.isArray(category) ? category : [];
    try {
      if (!(typeof window !== 'undefined' && window.innerWidth <= 767)) return list;
    } catch (_) { return list; }
    const sel = Array.isArray(selectedCategories) ? selectedCategories.map(String) : [];
    if (!sel.length) return list;
    const idOf = (c) => String(c.id || c._id);
    const selectedItems = sel
      .map((id) => list.find((c) => idOf(c) === id))
      .filter(Boolean);
    const selectedSet = new Set(selectedItems.map(idOf));
    const rest = list.filter((c) => !selectedSet.has(idOf(c)));
    return [...selectedItems, ...rest];
  }, [category, selectedCategories]);

  const computeMobileStickyOffset = () => {
    if (typeof window === 'undefined') return 0;
    if (window.innerWidth > 767) return 80;
    let offset = 12;
    const navbar = document.querySelector('.mobile-navbar');
    if (navbar && navbar.offsetParent !== null) {
      const rect = navbar.getBoundingClientRect();
      if (rect.height > 0) offset += rect.height;
    }
    const filtersEl = filtersStickyRef.current;
    if (filtersEl) {
      const styles = window.getComputedStyle(filtersEl);
      if ((styles.position === 'sticky' || styles.position === 'fixed') && styles.display !== 'none') {
        const rect = filtersEl.getBoundingClientRect();
        if (rect.height > 0) offset += rect.height;
      }
    }
    const maxOffset = window.innerHeight - 48;
    return Math.max(0, Math.min(offset, maxOffset > 0 ? maxOffset : offset));
  };

  const ensureEventsTopInView = (behavior = 'smooth') => {
    if (typeof window === 'undefined') return false;
    const target = eventsTopRef.current;
    if (!target) return false;
    const offset = computeMobileStickyOffset();
    try {
      target.style.scrollMarginTop = `${offset}px`;
    } catch (_) {}
    if (typeof target.scrollIntoView === 'function') {
      target.scrollIntoView({ behavior, block: 'start', inline: 'nearest' });
      return true;
    }
    const rect = target.getBoundingClientRect();
    const y = rect.top + (window.scrollY || window.pageYOffset || 0) - offset;
    window.scrollTo({ top: Math.max(0, y), behavior });
    return true;
  };

  // Scroll helper: programa un scroll al comienzo del bloque de resultados (no al top de la página)
  const scrollToEventsTop = () => {
    try {
      if (typeof window === 'undefined' || window.innerWidth > 767) return;
      pendingMobileScrollRef.current = true;
      window.requestAnimationFrame(() => {
        if (!pendingMobileScrollRef.current) return;
        const didScroll = ensureEventsTopInView('auto');
        if (didScroll) pendingMobileScrollRef.current = false;
      });
    } catch (_) {}
  };

  // Toggle de cajas de medios de pago
  const [openPay, setOpenPay] = useState({ cards: false, wallets: false });
  const trackEventSelection = (item, source = "event_list") => {
    if (isPreview || !item?._id) return;
    if (!loadMetaPixel()) return;
    trackMetaPixel("ViewContent", {
      content_name: item?.name || "Evento",
      content_ids: [String(item._id)],
      content_type: "event",
      source,
    });
  };
  const trackSearchIntent = () => {
    if (isPreview) return;
    const terms = [
      selectedCategory,
      selectedState,
      selectedCity,
      selectedVenue,
      location?.state?.search,
    ]
      .map((value) => String(value || "").trim())
      .filter(Boolean)
      .join(" | ");
    if (!loadMetaPixel()) return;
    trackMetaPixel("Search", {
      search_string: terms || "event_search",
    });
  };
  // Simple handler for the subscribe form in the empty state
  const handleSubscribe = (e) => {
    e.preventDefault();
    try {
      const form = e.currentTarget;
      const data = new FormData(form);
      const email = String(data.get("email") || "").trim();
      if (!email) return;
      toast.success("¡Gracias! Te avisaremos cuando haya eventos.");
      form.reset();
    } catch (_) {}
  };

  const renderPageNumbers = () => {
    let startPage = Math.max(1, pagination.currentPage - Math.floor(maxVisiblePages / 2));
    const endPage = Math.min(pagination.totalPages, startPage + maxVisiblePages - 1);

    if (endPage - startPage + 1 < maxVisiblePages) {
      startPage = Math.max(1, endPage - maxVisiblePages + 1);
    }

    const pageNumbers = [];
    if (startPage > 1) {
      pageNumbers.push(
        <Pagination.Item key={1} onClick={() => filterEvent(selectedFilter, 1)}>
          1
        </Pagination.Item>
      );
      if (startPage > 2) {
        pageNumbers.push(<Pagination.Ellipsis key="startEllipsis" />);
      }
    }
    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(
        <Pagination.Item key={i} active={i === pagination.currentPage} onClick={() => filterEvent(selectedFilter, i)}>
          {i}
        </Pagination.Item>
      );
    }
    if (endPage < pagination.totalPages) {
      if (endPage < pagination.totalPages - 1) {
        pageNumbers.push(<Pagination.Ellipsis key="endEllipsis" />);
      }
      pageNumbers.push(
        <Pagination.Item key={pagination.totalPages} onClick={() => filterEvent(selectedFilter, pagination.totalPages)}>
          {pagination.totalPages}
        </Pagination.Item>
      );
    }

    return pageNumbers;
  };

  // Aplicar filtros (precio y fecha) en cliente
  const eventsToRender = useMemo(() => {
    const list = Array.isArray(event) ? event : [];
    const stateName = (() => {
      try { return (state || []).find((s) => String(s._id) === String(selectedState))?.name || ""; } catch { return ""; }
    })();
    const cityName = (() => {
      try { return (city || []).find((c) => String(c._id) === String(selectedCity))?.name || ""; } catch { return ""; }
    })();
    const venueName = (() => {
      try { return (venues || []).find((v) => String(v._id) === String(selectedVenue))?.address || (venues || []).find((v)=> String(v._id)===String(selectedVenue))?.name || ""; } catch { return ""; }
    })();

    const normalizeId = (val) => {
      if (!val) return "";
      if (typeof val === 'object') return String(val._id || val.id || "");
      return String(val);
    };

    const matchLocation = (ev) => {
      try {
        // Extract candidate IDs from various shapes
        const stId = normalizeId(ev.stateid || ev.state || ev?.venueid?.state || ev?.venue?.state);
        const ctId = normalizeId(ev.cityid || ev.city || ev?.venueid?.city || ev?.venue?.city);
        const vnId = normalizeId(ev.venueid || ev.venue);

        if (selectedVenue) {
          if (vnId) return String(vnId) === String(selectedVenue);
          // fallback text contains
          const full = String(ev.fulladdress || ev?.venueid?.address || ev?.venue?.address || "");
          return venueName ? full.toLowerCase().includes(String(venueName).toLowerCase()) : true;
        }
        if (selectedCity) {
          if (ctId) return String(ctId) === String(selectedCity);
          const full = String(ev.fulladdress || "");
          return cityName ? full.toLowerCase().includes(String(cityName).toLowerCase()) : true;
        }
        if (selectedState) {
          if (stId) return String(stId) === String(selectedState);
          const full = String(ev.fulladdress || "");
          return stateName ? full.toLowerCase().includes(String(stateName).toLowerCase()) : true;
        }
        return true;
      } catch {
        return true;
      }
    };

    return list.filter((it) => {
      const price = it.isFree ? 0 : (minPrices[it._id] ?? it.price ?? 0);
      const okPrice = !priceRangeValues
        ? true
        : price >= priceRangeValues[0] && price <= priceRangeValues[1];
      const okDate = (() => {
        const d = dayjs(String(it.startDate || it.date || it.start_date || '').slice(0,10));
        if (!d.isValid()) return true;
        if (dateRangeValues && dateRangeValues[0] && dateRangeValues[1]) {
          const [a,b] = dateRangeValues;
          return d.isAfter(dayjs(a).startOf('day').subtract(1,'ms')) && d.isBefore(dayjs(b).endOf('day').add(1,'ms'));
        }
        if (dateSelected) {
          return d.isSame(dateSelected, 'day');
        }
        return true;
      })();
      const okLoc = matchLocation(it);
      return okPrice && okDate && okLoc;
    });
  }, [event, priceRangeValues, dateSelected, dateRangeValues, minPrices, selectedState, selectedCity, selectedVenue, state, city, venues]);

  const mobileHeroEvents = useMemo(() => {
    const list = featuredEvents?.length ? featuredEvents : eventsToRender;
    return Array.isArray(list) ? list.slice(0, 6) : [];
  }, [featuredEvents, eventsToRender]);

  const mobileHeroSlides = useMemo(() => {
    const baseSlides = mobileHeroEvents
      .map((eventItem) => {
        const posterUri =
          eventItem?.mobileimage ||
          eventItem?.mobileImage ||
          eventItem?.image ||
          eventItem?.banner ||
          eventItem?.cover;
        const eventId = eventItem?._id || eventItem?.id;
        if (!posterUri) return null;
        return { posterUri, eventId, event: eventItem };
      })
      .filter(Boolean);
    const sourceSlides = baseSlides.length ? baseSlides : [{ posterUri: HERO_FALLBACK_POSTER }];
    const slides = [];
    sourceSlides.forEach((slide, idx) => {
      const posterUri = slide?.posterUri || HERO_FALLBACK_POSTER;
      const explicitVideo =
        HERO_MOBILE_VIDEOS_ENABLED && typeof slide?.videoUri === "string" ? slide.videoUri : null;
      const eventVideos = HERO_MOBILE_VIDEOS_ENABLED
        ? normalizeVideoList(
            slide?.event?.featuredVideos ||
              slide?.event?.featuredVideo ||
              slide?.event?.featuredvideos ||
              slide?.event?.videos ||
              slide?.event?.videoList ||
              slide?.event?.featuredVideoList ||
              slide?.featuredVideos ||
              slide?.featuredVideo
          )
        : [];
      const candidates = explicitVideo ? [explicitVideo] : eventVideos;
      if (HERO_MOBILE_VIDEOS_ENABLED && candidates.length) {
        candidates.forEach((videoUri) => {
          slides.push({ ...slide, posterUri, videoUri });
        });
        return;
      }
      slides.push({
        ...slide,
        posterUri,
        videoUri: HERO_MOBILE_VIDEOS_ENABLED
          ? HERO_FALLBACK_VIDEOS[idx % HERO_FALLBACK_VIDEOS.length]
          : null,
      });
    });
    return slides.length ? slides : sourceSlides;
  }, [mobileHeroEvents]);

  const desktopHeroSlides = useMemo(() => {
    const list = Array.isArray(featuredEvents) ? featuredEvents : [];
    return list.map((eventItem, idx) => {
      const posterUri =
        eventItem?.image ||
        eventItem?.mobileimage ||
        eventItem?.mobileImage ||
        eventItem?.banner ||
        eventItem?.cover ||
        HERO_FALLBACK_POSTER;
      const videos = HERO_DESKTOP_VIDEOS_ENABLED
        ? normalizeVideoList(
            eventItem?.featuredVideos ||
              eventItem?.featuredVideo ||
              eventItem?.featuredvideos ||
              eventItem?.videos ||
              eventItem?.videoList ||
              eventItem?.featuredVideoList ||
              eventItem?.video
          )
        : [];
      return {
        ...eventItem,
        posterUri,
        // Temporal: en desktop forzamos videos fijos para evitar tomar los antiguos desde backend.
        videoUri: HERO_DESKTOP_VIDEOS_ENABLED
          ? HERO_FALLBACK_VIDEOS[idx % HERO_FALLBACK_VIDEOS.length]
          : null,
      };
    });
  }, [featuredEvents]);

  useEffect(() => {
    return () => {
      if (desktopHeroAdvanceTimerRef.current) {
        clearTimeout(desktopHeroAdvanceTimerRef.current);
        desktopHeroAdvanceTimerRef.current = null;
      }
    };
  }, []);

  useEffect(() => {
    if (!HERO_DESKTOP_VIDEOS_ENABLED || isMobile) return;
    if (desktopHeroAdvanceTimerRef.current) {
      clearTimeout(desktopHeroAdvanceTimerRef.current);
      desktopHeroAdvanceTimerRef.current = null;
    }
    const total = desktopHeroSlides.length;
    if (!total) return;
    const slide = desktopHeroSlides[activeHeroIndex % total];
    if (slide?.videoUri) return; // Si hay video, avanzamos al terminar (onEnded).
    desktopHeroAdvanceTimerRef.current = setTimeout(() => {
      desktopHeroCarouselRef.current?.next?.();
    }, DESKTOP_HERO_IMAGE_DURATION_MS);
  }, [activeHeroIndex, desktopHeroSlides, isMobile]);

  useEffect(() => {
    setActiveMobileHeroIndex(0);
  }, [mobileHeroSlides.length]);

  useEffect(() => {
    setActiveHeroIndex(0);
  }, [featuredEvents.length]);

  useEffect(() => {
    if (!pendingMobileScrollRef.current) return;
    if (typeof window === 'undefined' || window.innerWidth > 767) {
      pendingMobileScrollRef.current = false;
      return;
    }
    const handle = window.setTimeout(() => {
      const didScroll = ensureEventsTopInView('smooth');
      if (!didScroll) {
        pendingMobileScrollRef.current = false;
        return;
      }
      pendingMobileScrollRef.current = false;
    }, 60);
    return () => window.clearTimeout(handle);
  }, [eventsToRender, pagination.currentPage, selectedFilter, selectedCategories]);

  const fetchAppSettings = async () => {
    try {
      
      const response = await getAppSettings();
      if (response.status === 200) {
        setAppSettings(response.data.info);
      }
    } catch (error) {
      handleError(error);
     try { if (typeof window !== "undefined" && window.innerWidth <= 767) scrollToEventsTop(); } catch(_){} }
  };

  // Busca páginas adicionales hasta completar al menos INITIAL_EVENTS_MIN
  const fetchMoreUntilMin = async (baseData, existingList, paginationInfo, minCount = INITIAL_EVENTS_MIN) => {
    try {
      let list = Array.isArray(existingList) ? existingList.slice() : [];
      let pag = paginationInfo ? { ...paginationInfo } : { currentPage: 1, totalPages: 1 };
      const seen = new Set(list.map((e) => e && e._id));

      // Si ya cumple el mínimo o no hay más páginas, no hace falta continuar
      if (!pag || !pag.totalPages || list.length >= minCount) {
        return { list, pagination: pag };
      }

      while (list.length < minCount && pag.currentPage < pag.totalPages) {
        const nextPage = (pag.currentPage || 1) + 1;
        const resMore = await getSearchEvent(baseData, nextPage);
        if (!(resMore && resMore.status === 200)) break;
        const nextList = Array.isArray(resMore?.data?.info?.events) ? resMore.data.info.events : [];
        const nextPag = resMore?.data?.info?.pagination || { currentPage: nextPage, totalPages: pag.totalPages };

        for (const ev of nextList) {
          if (ev && ev._id && !seen.has(ev._id)) {
            seen.add(ev._id);
            list.push(ev);
          }
        }
        pag = { currentPage: nextPag.currentPage || nextPage, totalPages: nextPag.totalPages ?? pag.totalPages };
        if (!pag.totalPages) break;
      }
      return { list, pagination: pag };
    } catch (_) {
      return { list: Array.isArray(existingList) ? existingList : [], pagination: paginationInfo };
    }
  };

  const handleFirstClick = () => {
    if (swipereventRef.current) {
      swipereventRef.current.slideTo(swipereventRef.current.activeIndex);
    }
  };

  const handleLastClick = () => {
    if (swipereventRef.current) {
      swipereventRef.current.slideTo(swipereventRef.current.activeIndex);
    }
  };

  // Navegar al evento actualmente visible en el hero
  const navigateToCurrentHeroEvent = () => {
    try {
      const list = Array.isArray(featuredEvents) ? featuredEvents : [];
      if (!list.length) return;
      const ev = list[activeHeroIndex % list.length];
      if (ev && ev._id) {
        navigate(`/event/${ev._id}`, { state: { name: ev.name } });
      }
    } catch (_) {}
  };

  const handleDropdownToggle = (open) => {
    // setIsDropdownOpen(open);
  };

  const getcategory = async () => {
    try {
      
      const res = await getCategory();
      if (res.status === 200) {
        const list = Array.isArray(res.data.info) ? res.data.info.slice() : [];
        list.sort((a,b)=> String(a.name||"").localeCompare(String(b.name||""), 'es', { sensitivity: 'base' }));
        setCategory(list);
      }
    } catch (error) {
      handleError(error);
     try { if (typeof window !== "undefined" && window.innerWidth <= 767) scrollToEventsTop(); } catch(_){} }
  };

  // Reposiciona el carrusel de categorías al inicio en móvil cuando cambia la data
  useEffect(() => {
    try {
      if (typeof window !== 'undefined' && window.innerWidth <= 430 && categorySwiperRef.current) {
        const list = Array.isArray(category) ? category : [];
        const idxArte = list.findIndex((c) => String(c?.name || '').toLowerCase().startsWith('arte'));
        const target = idxArte >= 0 ? idxArte : 0;
        try { categorySwiperRef.current.updateSlides(); } catch(_){}
        try { categorySwiperRef.current.update(); } catch(_){}
        categorySwiperRef.current.slideTo(target, 0);
        setTimeout(() => { try { categorySwiperRef.current && categorySwiperRef.current.slideTo(target, 0); } catch(_){} }, 80);
      }
    } catch (_) {}
  }, [category]);

  useEffect(() => {
    try {
      if (typeof window === 'undefined' || window.innerWidth > 767) return;
      const swiper = categorySwiperRef.current;
      if (!swiper) return;
      const snapToStart = () => {
        try { swiper.setTranslate && swiper.setTranslate(0); } catch (_) {}
        try { swiper.slideTo(0, 0); } catch (_) {}
      };
      try { swiper.updateSlides && swiper.updateSlides(); } catch (_) {}
      try { swiper.update && swiper.update(); } catch (_) {}
      snapToStart();
      setTimeout(snapToStart, 90);
    } catch (_) {}
  }, [categoryOrdered, selectedCategories]);

  const getstate = async () => {
    try {
      const res = await getState();
      if (res.status === 200) {
        const list = Array.isArray(res.data.info) ? res.data.info.slice() : [];
        list.sort((a,b)=> String(a.name||"").localeCompare(String(b.name||""), 'es', { sensitivity: 'base' }));
        setState(list);
      }
    } catch (error) {
      handleError(error);
     try { if (typeof window !== "undefined" && window.innerWidth <= 767) scrollToEventsTop(); } catch(_){} }
  };

  const getcity = async (state_id) => {
    try {
      const data = {
        stateId: state_id,
      };
      const res = await getCityByStateId(data);
      if (res.status === 200) {
        const list = Array.isArray(res.data.info) ? res.data.info.slice() : [];
        list.sort((a,b)=> String(a.name||"").localeCompare(String(b.name||""), 'es', { sensitivity: 'base' }));
        setCity(list);
      }
    } catch (error) {
      handleError(error);
     try { if (typeof window !== "undefined" && window.innerWidth <= 767) scrollToEventsTop(); } catch(_){} }
  };
  const getvenue = async (city_id) => {
    try {
      const data = {
        cityId: city_id,
      };
      const res = await getVenueByCityId(data);
      if (res.status === 200) {
        const list = Array.isArray(res.data.info) ? res.data.info.slice() : [];
        list.sort((a,b)=> String(a.address||a.name||"").localeCompare(String(b.address||b.name||""), 'es', { sensitivity: 'base' }));
        setVenues(list);
      }
    } catch (error) {
      handleError(error);
     try { if (typeof window !== "undefined" && window.innerWidth <= 767) scrollToEventsTop(); } catch(_){} }
  };

  const searchevent = async (page = 1) => {
    const showLoading = page === 1;
    if (showLoading) setIsLoading(true);
    try {
      const data = {
        categoryid: selectedCategory,
        // enviar ambas variantes para compatibilidad con API
        statedid: selectedState,
        stateid: selectedState,
        stateId: selectedState,
        cityid: selectedCity,
        cityId: selectedCity,
        // por compatibilidad extrema
        cityIdd: selectedCity,
        venueid: selectedVenue,
        venueId: selectedVenue,
        statedId: selectedState,
      };

      const res = await getSearchEvent(data, page);

      if (res.status === 200) {
        let list = res.data.info.events || [];
        let pagInfo = {
          currentPage: res.data.info.pagination.currentPage,
          totalPages: res.data.info.pagination.totalPages,
        };

        // Completar hasta 9 eventos en la carga inicial
        if (page === 1) {
          const extra = await fetchMoreUntilMin(data, list, pagInfo, INITIAL_EVENTS_MIN);
          list = extra.list;
          pagInfo = extra.pagination;
        }

        const orderedList = sortEventsForHome(list);
        setEvent(orderedList);
        setPagination(pagInfo);
        setSelectedFilter("Upcoming Events");
        // precargar precios ms baratos por evento
        preloadMinPrices(orderedList);
      }
    } catch (error) {
      handleError(error);
     try { if (typeof window !== "undefined" && window.innerWidth <= 767) scrollToEventsTop(); } catch(_){} }
    finally {
      if (showLoading) setIsLoading(false);
    }
  };

  // Permite overrides para evitar carreras al setear estado y filtrar inmediatamente
  const filterEvent = async (sort, page = 1, overrides = {}, opts = {}) => {
    const showLoading = !(opts && opts.append);
    if (showLoading) setIsLoading(true);
    try {
      const cat = overrides.categoryid !== undefined ? overrides.categoryid : selectedCategory;
      const st = overrides.stateid !== undefined ? overrides.stateid : (overrides.stateId !== undefined ? overrides.stateId : selectedState);
      const ct = overrides.cityid !== undefined ? overrides.cityid : (overrides.cityId !== undefined ? overrides.cityId : selectedCity);
      const vn = overrides.venueid !== undefined ? overrides.venueid : (overrides.venueId !== undefined ? overrides.venueId : selectedVenue);
      const data = {
        categoryid: cat,
        // enviar ambas variantes para compatibilidad con API
        statedid: st,
        stateid: st,
        stateId: st,
        cityid: ct,
        cityId: ct,
        cityIdd: ct,
        venueid: vn,
        venueId: vn,
        statedId: st,
        sort: sort,
      };
      const res = await getSearchEvent(data, page);

      if (res.status === 200) {
        let list = res.data.info.events || [];
        if (opts && opts.append) {
          setEvent((prev) => {
            const prevArr = Array.isArray(prev) ? prev : [];
            const existing = new Set(prevArr.map((e) => e._id));
            const merged = [...prevArr];
            for (const e of list) {
              if (!existing.has(e._id)) merged.push(e);
            }
            return sortEventsForHome(merged);
          });
          setPagination({
            currentPage: res.data.info.pagination.currentPage,
            totalPages: res.data.info.pagination.totalPages,
          });
        } else {
          // En cargas iniciales/filtrados, completar hasta 9 antes de mostrar "Ver más"
          let pagInfo = {
            currentPage: res.data.info.pagination.currentPage,
            totalPages: res.data.info.pagination.totalPages,
          };
          if (page === 1) {
            const extra = await fetchMoreUntilMin(data, list, pagInfo, INITIAL_EVENTS_MIN);
            list = extra.list;
            pagInfo = extra.pagination;
          }
          const orderedList = sortEventsForHome(list);
          setEvent(orderedList);
          setPagination(pagInfo);
          list = orderedList;
        }
        setSelectedFilter(sort);
        preloadMinPrices(list);
        try {
          if (typeof window !== 'undefined' && window.innerWidth <= 767) {
            setTimeout(() => { try { scrollToEventsTop(); } catch (_) {} }, 16);
          }
        } catch (_) {}
      }
    } catch (error) {
      handleError(error);
     try { if (typeof window !== "undefined" && window.innerWidth <= 767) scrollToEventsTop(); } catch(_){} }
    finally {
      if (showLoading) setIsLoading(false);
    }
  };

  const [isLoadMoreLoading, setIsLoadMoreLoading] = useState(false);
  const loadMore = async () => {
    try {
      if (pagination.currentPage >= pagination.totalPages) return;
      setIsLoadMoreLoading(true);
      await filterEvent(selectedFilter, pagination.currentPage + 1, {}, { append: true });
    } catch (e) {
      // noop
    } finally {
      setIsLoadMoreLoading(false);
    }
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (!location.state) {
      searchevent();
    }
    getcategory();
    getstate();
  }, [location.state]);

  // Cargar min price por evento (desde ticketTypes) en segundo plano
  const preloadMinPrices = async (eventsList) => {
    try {
      const pairs = await Promise.all(
        (eventsList || []).map(async (ev) => {
          try {
            const resp = await getEventById(ev._id);
            const types = resp?.data?.info?.ticketTypes || [];
            const min = types.length ? Math.min(...types.map((t) => Number(t.price || 0))) : undefined;
            return [ev._id, min];
          } catch (_) {
            return [ev._id, undefined];
          }
        })
      );
      const map = {};
      for (const [id, min] of pairs) {
        if (typeof min === "number" && !Number.isNaN(min)) map[id] = min;
      }
      setMinPrices((prev) => ({ ...prev, ...map }));
    } catch (_) {}
  };

  const renderPrice = (it) => {
    if (it.isFree) return "Gratis";
    const p = minPrices[it._id] ?? it.price ?? 0;
    // Mostrar "Desde" cuando el ms barato viene de tipos
    const prefix = minPrices[it._id] !== undefined && (!it.price || it.price === 0) ? "Desde " : "";
    return `${prefix}${appSettings.currency} ${p}`;
  };

  // Clear all filters
  const clearAllFilters = () => {
    setSelectedCategory("");
    setSelectedCategories([]);
    setSelectedState("");
    setSelectedCity("");
    setSelectedVenue("");
    setSelectedFilter(defaultDateFilter);
    setPriceRangeValues(null);
    setDateSelected(null);
    setDateRangeValues(null);
    filterEvent(defaultDateFilter, 1, { categoryid: "", stateid: "", cityid: "", venueid: "" });
    try {
      if (typeof window !== 'undefined' && window.innerWidth <= 767) {
        scrollToEventsTop();
      } else if (typeof window !== 'undefined') {
        window.scrollTo({ top: 0, behavior: "smooth" });
      }
    } catch (_) {}
  };
  const hasActiveFilters = (
    (selectedCategories && selectedCategories.length > 0) || selectedState || selectedCity || selectedVenue ||
    selectedFilter !== defaultDateFilter || priceRangeValues !== null || dateSelected !== null || dateRangeValues !== null
  );

  useEffect(() => {
    if (location.state) {
      if (location.state?.stateId) { getcity(location.state.stateId); }
      if (location.state?.cityId) { getvenue(location.state.cityId); }
      if (location.state?.categoryId) { setSelectedCategory(location.state.categoryId); setSelectedCategories([location.state.categoryId]); }
      if (location.state?.stateId) { setSelectedState(location.state.stateId); }
      if (location.state?.cityId) { setSelectedCity(location.state.cityId); }
      if (location.state?.venueId) { setSelectedVenue(location.state.venueId); }
      if (location.state?.sort) { setSelectedFilter(location.state.sort); }
    }
    if (location.state) {
      const searchevent = async (page = 1) => {
        const showLoading = page === 1;
        if (showLoading) setIsLoading(true);
        try {
          
            const data = {
            categoryid: location.state?.categoryId,
            // Compatibilidad con backend: ambas variantes
            statedid: location.state?.stateId,
            stateid: location.state?.stateId,
            stateId: location.state?.stateId,
            cityid: location.state?.cityId,
            cityId: location.state?.cityId,
            cityIdd: location.state?.cityId,
            venueid: location.state?.venueId,
            venueId: location.state?.venueId,
            statedId: location.state?.stateId,
            search: location.state?.search,
            sort: location.state?.sort,
          };

          const res = await getSearchEvent(data, page);

          if (res.status === 200) {
            let list = res.data.info.events || [];
            let pagInfo = {
              currentPage: res.data.info.pagination.currentPage,
              totalPages: res.data.info.pagination.totalPages,
            };
            // Completar hasta 9 eventos cuando la navegación viene con filtros en state
            if (page === 1) {
              const extra = await fetchMoreUntilMin(data, list, pagInfo, INITIAL_EVENTS_MIN);
              list = extra.list;
              pagInfo = extra.pagination;
            }
            setPagination(pagInfo);
            const orderedList = sortEventsForHome(list);
            setEvent(orderedList);
            list = orderedList;
            setSelectedFilter(location.state.sort);
          }
        } catch (error) {
          handleError(error);
         try { if (typeof window !== "undefined" && window.innerWidth <= 767) scrollToEventsTop(); } catch(_){} }
        finally {
          if (showLoading) setIsLoading(false);
        }
      };
      searchevent();
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, [location.state]);

  // FunciÃ³n para aplicar/mantener selecciÃ³n de mÃºltiples categorÃ­as
  const applyCategorySelection = async (nextCats) => {
    try {
      try {
        if (typeof window !== 'undefined' && window.innerWidth <= 767) {
          scrollToEventsTop();
        }
      } catch (_) {}
      setSelectedCategories(nextCats);
      setSelectedCategory(nextCats[0] || "");
      if (!nextCats || nextCats.length === 0) {
        await filterEvent(selectedFilter, 1, { categoryid: "" });
        return;
      }
      if (nextCats.length === 1) {
        await filterEvent(selectedFilter, 1, { categoryid: nextCats[0] });
        return;
      }
      // 2 o mÃ¡s categorÃ­as: combinar resultados del backend
      
      const otherParams = {
        statedid: selectedState,
        stateid: selectedState,
        stateId: selectedState,
        cityid: selectedCity,
        cityId: selectedCity,
        cityIdd: selectedCity,
        venueid: selectedVenue,
        venueId: selectedVenue,
        statedId: selectedState,
      };
      const responses = await Promise.all(
        nextCats.map(async (catId) => {
          try {
            const data = { categoryid: catId, ...otherParams, sort: selectedFilter };
            const res = await getSearchEvent(data, 1);
            return Array.isArray(res?.data?.info?.events) ? res.data.info.events : [];
          } catch (e) {
            return [];
          }
        })
      );
      const mergedMap = new Map();
      for (const arr of responses) {
        for (const ev of arr) mergedMap.set(ev._id, ev);
      }
      const merged = sortEventsForHome(Array.from(mergedMap.values()));
      setEvent(merged);
      setPagination({ currentPage: 1, totalPages: 1 });
      preloadMinPrices(merged);
    } catch (e) {
      // noop
    } finally {
      try {
        if (typeof window !== 'undefined' && window.innerWidth <= 767) {
          setTimeout(() => { try { scrollToEventsTop(); } catch(_){} }, 0);
        }
      } catch(_){}
    }
  };
  

  useEffect(() => {
    AOS.init({
      disable: function () {
        return window.innerWidth < 600;
      },
    });
    window.scrollTo(0, 0);
    fetchAppSettings();
    // cargar eventos destacados para el hero
    (async () => {
      try {
        const res = await getFeaturedEvent();
        const list = Array.isArray(res?.data?.info) ? res.data.info : [];
        setFeaturedEvents(sortEventsForHome(list));
      } catch (e) {
        console.error("No se pudo cargar destacados para hero", e);
      }
    })();
  }, []);
  return (
    <>
      {isLoading && <SpinLoading />}
      <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} newestOnTop={false} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover theme="light" />
      {/* Mobile hero carousel of events (Swiper) */}
      {isMobile && mobileHeroSlides.length > 0 && (
        <div className="pading150 mobile-hero-wrapper">
          <Swiper
            className="mobile-hero-swiper"
            slidesPerView={1.1}
            spaceBetween={14}
            modules={[Navigation]}
            onSwiper={(swiper) => {
              mobileHeroSwiperRef.current = swiper;
              try {
                const videos = swiper?.el?.querySelectorAll(".mobile-slide-video") || [];
                videos.forEach((video) => {
                  video.pause();
                  try {
                    video.currentTime = 0;
                  } catch (_) {}
                });
              } catch (_) {}
            }}
            onSlideChange={(swiper) => {
              const idx = swiper?.activeIndex ?? 0;
              setActiveMobileHeroIndex(idx);
              try {
                const videos = swiper?.el?.querySelectorAll(".mobile-slide-video") || [];
                videos.forEach((video) => {
                  video.pause();
                  try {
                    video.currentTime = 0;
                  } catch (_) {}
                });
              } catch (_) {}
            }}
          >
            {mobileHeroSlides.map((slide, i) => {
              const eventItem = slide?.event || {};
              const poster = slide?.posterUri;
              const videoUri = slide?.videoUri;
              const isActive = i === activeMobileHeroIndex;
              const showVideo = Boolean(videoUri) && isActive && mobileHeroVideoDelayDone;
              const hideMobileHeroText = readHideMobileHeroText(eventItem);
              const eventId = slide?.eventId || eventItem?._id || eventItem?.id;
              const eventName = eventItem?.name || eventItem?.title || "Evento destacado";
              return (
                <SwiperSlide key={slide?.eventId || slide?.posterUri || `mh-${i}`}>
                  <div
                    className={`mobile-slide-card${showVideo ? " is-video" : ""}${hideMobileHeroText ? " is-text-hidden" : ""}`}
                    role="button"
                    tabIndex={0}
                    onClick={() => {
                      if (!eventId) return;
                      navigate(`/event/${eventId}`, { state: { name: eventItem?.name } });
                    }}
                  >
                    {videoUri ? (
                      <video
                        className="mobile-slide-video"
                        src={videoUri}
                        poster={poster}
                        muted
                        playsInline
                        loop
                        autoPlay
                        preload="metadata"
                        data-slide-index={i}
                      />
                    ) : null}
                    <img
                      className="mobile-slide-img"
                      src={poster}
                      alt={eventName}
                      width={360}
                      height={640}
                      loading={heroImgLoading(i)}
                      decoding="async"
                      fetchPriority={heroImgPriority(i)}
                    />
                    <div className="mobile-slide-gradient" />
                    {!hideMobileHeroText && (
                      <div className="mobile-slide-content">
                        {(() => {
                          const titleSvgUri =
                            eventItem?.titleSvg ||
                            eventItem?.titleSVG ||
                            eventItem?.titleSvgUrl ||
                            eventItem?.titleSvgURI ||
                            eventItem?.titleLogoSvg ||
                            eventItem?.titleLogo;
                          const description =
                            eventItem?.subtitle ||
                            eventItem?.tagline ||
                            eventItem?.shortDescription ||
                            eventItem?.description ||
                            "Una experiencia unica en vivo. No te la pierdas.";
                          return (
                            <>
                              <div className="mobile-slide-title-wrap">
                                {titleSvgUri ? (
                                  <img
                                    className="mobile-slide-title-svg"
                                    src={titleSvgUri}
                                    alt={eventName}
                                    loading={heroImgLoading(i)}
                                    decoding="async"
                                  />
                                ) : (
                                  <div className="mobile-slide-title">{eventItem?.name || "Evento"}</div>
                                )}
                              </div>
                              <div className="mobile-slide-description">{description}</div>
                            </>
                          );
                        })()}
                      </div>
                    )}
                  </div>
                </SwiperSlide>
              );
            })}
          </Swiper>
        </div>
      )}
      {/* Hero de eventos destacados */}
      {featuredEvents.length > 0 && (
        <div className="EventHero">
          <div
            ref={desktopHeroRef}
            className="event-hero-bg"
            onClick={(e) => {
              const el = e.target;
              try {
                if (el && (el.closest && (el.closest('.event-hero-dots') || el.closest('.slick-dots') || el.closest('.event-hero-cta')))) {
                  return; // evitar navegar al tocar los puntos u el CTA
                }
              } catch (_) {}
              navigateToCurrentHeroEvent();
            }}
          >
            <Carousel
              ref={desktopHeroCarouselRef}
              autoplay={false}
              effect="fade"
              dots={{ className: "event-hero-dots" }}
              speed={300}
              afterChange={(i) => setActiveHeroIndex(i)}
            >
              {desktopHeroSlides.map((slide, i) => {
                const videoUri = slide?.videoUri;
                const posterUri = slide?.posterUri || slide?.image || HERO_FALLBACK_POSTER;
                const showVideo = Boolean(videoUri) && !isMobile && i === activeHeroIndex;
                return (
                  <div key={slide?._id || i} className={`event-hero-slide${showVideo ? " is-video" : ""}`}>
                    {videoUri ? (
                      <video
                        className="event-hero-video"
                        src={videoUri}
                        poster={posterUri}
                        muted
                        playsInline
                        autoPlay
                        preload="metadata"
                        data-slide-index={i}
                        onError={() => {
                          if (isMobile || i !== activeHeroIndex) return;
                          desktopHeroCarouselRef.current?.next?.();
                        }}
                        onEnded={() => {
                          if (isMobile || i !== activeHeroIndex) return;
                          desktopHeroCarouselRef.current?.next?.();
                        }}
                      />
                    ) : null}
                    <img
                      src={posterUri}
                      alt={slide?.name || `Evento destacado ${i + 1}`}
                      width={1250}
                      height={656}
                      loading={heroImgLoading(i)}
                      decoding="async"
                      fetchPriority={heroImgPriority(i)}
                    />
                  </div>
                );
              })}
            </Carousel>
            <div className="event-hero-overlay" />
          </div>

          {/* Tarjeta con info del slide activo */}
          {featuredEvents[activeHeroIndex % featuredEvents.length] && (
            <div
              className="event-hero-card"
              onClick={() => navigateToCurrentHeroEvent()}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); navigateToCurrentHeroEvent(); } }}
            >
              <div className="event-hero-title">
                {featuredEvents[activeHeroIndex % featuredEvents.length].name}
              </div>
              <div className="event-hero-meta">
                <div className="event-hero-line">
                   <img src={Calendar} alt="calendario" style={{width: 22, height: 22}} />
                  <span className="featuredEventsHero">
                    {dayjs(String(featuredEvents[activeHeroIndex % featuredEvents.length].startDate || '').slice(0,10)).format("DD MMM. - YYYY")}
                  </span>
                </div>
                <div className="event-hero-line">
                   <img src={ubi} alt="calendario" style={{width: 22, height: 22}} />
                  <span className="featuredEventsHero">{featuredEvents[activeHeroIndex % featuredEvents.length].fulladdress}</span>
                </div>
              </div>
              <div>
                <Button
                  className="event-hero-cta"
                  onClick={(e) => {
                    e.stopPropagation();
                    const ev = featuredEvents[activeHeroIndex % featuredEvents.length];
                    navigate(`/event/${ev._id}`, { state: { name: ev.name } });
                  }}
                >
                  Ver tickets
                </Button>
              </div>
            </div>
          )}
        </div>
      )}
      {/* Filtros tipo Figma (nuevos) */}
      <div ref={filtersStickyRef} className="pading150 event-filters-figma">
        <div className="filters-row">
 {/* UbicaciÃ³n */}
          <PillDropdown
            widthClass="w-380"
            iconSrc={ubi}
            value={selectedState}
            options={[{ value: "", label: "Ubicación" }, ...state.map((s) => ({ value: s._id, label: s.name }))]}
            onChange={(v) => {
              setSelectedState(v);
              setSelectedCity("");
              setSelectedVenue("");
              if (v) getcity(v);
              filterEvent(selectedFilter, 1, { stateid: v, cityid: "", venueid: "" });
            }}
          />
          

          {/* Fecha */}
          <DateFilterPill
            widthClass="w-300"
            rangeValue={dateRangeValues}
            dayValue={dateSelected}
            onApply={({ range, day }) => {
              setDateRangeValues(range ? range.map((v) => (v ? dayjs(v) : null)) : null);
              setDateSelected(day ? dayjs(day) : null);
            }}
          />

          {/* Precio */}
          <PriceRangePill
            widthClass="w-260"
            value={priceRangeValues}
            onApply={(vals) => setPriceRangeValues(vals)}
          />

          
        </div>

        {/* CategorÃ­as como tarjetas */}
        <div className="category-grid" style={{ justifyContent: "center"}}>
          {categoryOrdered.map((cat) => {
            const id = cat.id || cat._id;
            const active = Array.isArray(selectedCategories) && selectedCategories.includes(id);
            return (
              <button
                type="button"
                key={id}
                className={`category-card ${active ? 'active' : ''}`}
                onClick={() => {
                  const next = active ? selectedCategories.filter((x)=> x !== id) : [...(selectedCategories||[]), id];
                  applyCategorySelection(next);
                }}
              >
                {active && (
                  <button
                    type="button"
                    className="chip-close"
                    aria-label="Quitar"
                    onClick={(e) => {
                      e.stopPropagation();
                      const next = (selectedCategories||[]).filter((x)=> x !== id);
                      applyCategorySelection(next);
                    }}
                  >
                     <img src={cruze} alt="cruze" style={{width: 14, height: 14 }} />
                  </button>
                )}
                <span className="icon-svg">{renderCategoryIcon(cat.name)}</span>
                <span className="label">{cat.name}</span>
              </button>
            );
          })}
        </div>
        

        {/* Carrusel de categorÃ­as (8 visibles, 21px gap) */}
        <Swiper
          key={'cat-sw'}
          centeredSlidesBounds
          className="category-swiper"
          slidesPerView={8}
          spaceBetween={21}
          modules={[Navigation]}
          initialSlide={typeof window !== 'undefined' && window.innerWidth <= 430 ? 0 : 0}
          observer
          observeParents
          watchOverflow
          allowTouchMove
          slidesOffsetBefore={0}
          slidesOffsetAfter={0}
          onBeforeInit={(swiper) => {
            try {
              if (typeof window !== 'undefined' && window.innerWidth <= 430) {
                swiper.setTranslate(0);
                swiper.slideTo(0, 0);
              }
            } catch (_) {}
          }}
          onSwiper={(swiper) => {
            try {
              categorySwiperRef.current = swiper;
              if (typeof window !== 'undefined' && window.innerWidth <= 430) {
                // ejecutar dos veces por seguridad tras layout
                swiper.setTranslate(0);
                swiper.slideTo(0, 0);
                setTimeout(() => { try { swiper.slideTo(0, 0); } catch(_){} }, 50);
              }
            } catch (_) {}
          }}
          onResize={(swiper) => {
            try {
              if (typeof window !== 'undefined' && window.innerWidth <= 430) {
                setTimeout(() => { try { swiper.setTranslate(0); swiper.slideTo(0, 0); } catch(_){} }, 0);
              }
            } catch (_) {}
          }}
          breakpoints={{
            1600: { slidesPerView: 8, spaceBetween: 21, centeredSlides: false },
            1400: { slidesPerView: 8, spaceBetween: 21, centeredSlides: false },
            1200: { slidesPerView: 7, spaceBetween: 21, centeredSlides: false },
            1024: { slidesPerView: 6, spaceBetween: 21, centeredSlides: false },
            900:  { slidesPerView: 5, spaceBetween: 21, centeredSlides: false },
            768:  { slidesPerView: 4, spaceBetween: 18, centeredSlides: false },
            520:  { slidesPerView: 3, spaceBetween: 16, centeredSlides: false },
            0:    { slidesPerView: 'auto', spaceBetween: 12, centeredSlides: false },
          }}
        >
          {categoryOrdered.map((cat) => {
            const id = cat.id || cat._id;
            const active = Array.isArray(selectedCategories) && selectedCategories.includes(id);
            return (
              <SwiperSlide style={{ maxWidth: '128px'}} key={id}>
                <button
                  type="button"
                  className={`category-card ${active ? 'active' : ''}`}
                  onClick={() => {
                    const next = active ? selectedCategories.filter((x)=> x !== id) : [...(selectedCategories||[]), id];
                    applyCategorySelection(next);
                  }}
                  style={{ maxWidth: '128px'}}
                >
                  {active && (
                    <button
                      type="button"
                      className="chip-close"
                      aria-label="Quitar"
                      onClick={(e) => {
                        e.stopPropagation();
                        const next = (selectedCategories||[]).filter((x)=> x !== id);
                        applyCategorySelection(next);
                      }}
                    >
                    <img src={cruze} alt="cruze" style={{width: 14, height: 14, marginRight: 9}} />
                    </button>
                  )}
                  <img
                    src={active && cat.hoverimage ? cat.hoverimage : (cat.image || cat.icon || '')}
                    alt={cat.name}
                    className="category-icon"
                  />
                  <span className="label">{cat.name}</span>
                </button>
              </SwiperSlide>
            );
          })}
        </Swiper>
        {hasActiveFilters && (
          <div className="clear-filters-wrap below-categories">
            <button type="button" className="clear-filters-btn" onClick={clearAllFilters}>
              Borrar todo
            </button>
          </div>
        )}
      </div>

      <div className="pading150 event-search">
        <Row xs={2} md={2} lg={5} className="Searchhome3">
          <Col>
            <select
              onFocus={() => handleDropdownToggle(true)}
              onBlur={() => handleDropdownToggle(false)}
              onChange={(e) => {
                handleDropdownToggle(false);
                setSelectedCategory(e.target.value);
              }}
              size="lg"
              aria-label="Default select example"
              label="Categoría"
              value={selectedCategory}
              className=" search-event ellipsis-select"
            >
              <option value="">CategorÃ­a</option>
              {category.map((item) => (
                <option value={item.id || item._id}>{item.name}</option>
              ))}
            </select>
          </Col>
          <Col>
            <select
              onFocus={() => handleDropdownToggle(true)}
              onBlur={() => handleDropdownToggle(false)}
              onChange={(e) => {
                handleDropdownToggle(false);

                setSelectedState(e.target.value);
                if (e.target.value === "") {
                  setSelectedCity("");
                  setSelectedVenue("");
                } else {
                  getcity(e.target.value);
                  setSelectedCity("");
                  setSelectedVenue("");
                }
              }}
              value={selectedState}
              size="lg"
              aria-label="Provincia"
              className=" search-event ellipsis-select"
            >
              <option value="">Provincia</option>
              {state.map((item) => (
                <option value={item._id}>{item.name}</option>
              ))}
            </select>
          </Col>
          <Col>
            <select
              onFocus={() => handleDropdownToggle(true)}
              onBlur={() => handleDropdownToggle(false)}
              onChange={(e) => {
                handleDropdownToggle(false);
                setSelectedCity(e.target.value);
                if (e.target.value === "") {
                  setSelectedVenue("");
                } else {
                  getvenue(e.target.value);
                  setSelectedVenue("");
                }
              }}
              aria-label="Default select example"
              value={selectedCity}
              disabled={selectedState === "" || selectedState === null}
              label="Ciudad"
              className=" search-event ellipsis-select"
            >
              <option value="">Ciudad</option>
              {city.map((item) => (
                <option value={item._id}>{item.name}</option>
              ))}
            </select>
          </Col>
          <Col>
            <select
              onFocus={() => handleDropdownToggle(true)}
              onBlur={() => handleDropdownToggle(false)}
              onChange={(e) => {
                handleDropdownToggle(false);
                setSelectedVenue(e.target.value);
              }}
              aria-label="Default select example"
              value={selectedVenue}
              disabled={selectedCity === "" || selectedCity === null}
              label="Venue"
              className=" search-event ellipsis-select"
            >
              <option value="">Venue</option>
              {venues.map((item) => (
                <option value={item._id}>{item.address}</option>
              ))}
            </select>
          </Col>
          <Col md={12} xs={12}>
            <button className="buttonsearchevent" onClick={() => { trackSearchIntent(); searchevent(); }}>
              <span class="buttonsearcheventtransition"></span>
              <span class="label">Buscar eventos</span>
            </button>
          </Col>
        </Row>
      </div>
      <div ref={eventsTopRef} className="events-top-anchor" aria-hidden="true" />
      {eventsToRender.length > 0 ? (
        <>
          <div className="pading150-Desktopevent">
            <Row className="events-grid">
              {eventsToRender.map((item, index) => (
                <Col
                  sm={6}
                  md={6}
                  lg={4}
                  xl={4}
                  className="event-list"
                  data-aos="fade-up"
                  data-aos-duration={500 + index * 100}
                >
                    <Card
                      className="eventlist4 is-tappable"
                      onClick={() => {
                        trackEventSelection(item, "event_card");
                        navigate(`/event/${item._id}`, { state: { name: item.name } });
                      }}
                    role="button"
                    tabIndex={0}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        navigate(`/event/${item._id}`, { state: { name: item.name } });
                      }
                    }}
                  >
                    <div className="eventlistimagecontainer">
                      <Card.Img
                        variant="top"
                        className="eventlistimage"
                        src={isMobile ? (item.mobileimage || item.image) : item.image}
                        alt={item.name || "Evento"}
                        width={400}
                        height={216}
                        loading={listImgLoading(index)}
                        decoding="async"
                        fetchPriority={listImgPriority(index)}
                      />
                      <div className="eventlistimageoverlay">{renderPrice(item)}</div>
                      <div className="eventlistimageoverlay2">{dayjs(String(item.startDate || '').slice(0,10)).format("DD MMM, YYYY")}</div>
                    </div>

                    <Card.Body>
                      <Card.Title className="eventlistcardtitle">{item.name}</Card.Title>
                      <div className="event-meta">
                        <div className="meta-pill">
                          <img src={ubi} alt="calendario" style={{width: 20, height: 20 }} />
                          <span>{formatVenueCity(item.fulladdress)}</span>
                        </div>
                        <div className="meta-pill">
                          <img src={Calendar} alt="calendario" style={{width: 17, height: 17, marginRight: 2}} />
                          <span>{dayjs(String(item.startDate || '').slice(0,10)).format("D MMM. - YYYY")}</span>
                        </div>
                        <div className="meta-pill">
                          <img src={dolar} alt="calendario" style={{width: 17, height: 17}} />
                          <span>{renderPrice(item)}</span>
                        </div>
                      </div>
                      <div className="eventlistcardbutton">
                        <Button
                          className=""
                          onClick={(e) => {
                            e.stopPropagation();
                            trackEventSelection(item, "event_button");
                            navigate(`/event/${item._id}`, { state: { name: item.name } });
                          }}
                        >
                          <span class="eventlistbuttontransition"></span>
                          <span class="botonEvento"style={{color: "#fff"}}>
                            {item.endDate > dayjs().format("YYYY-MM-DD")
                              ? item.maxbooking > item.totalbooking
                                ? "Ver tickets"
                                : "Sin entradas"
                              : "Sin entradas"}
                          </span>
                        </Button>
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
              ))}
            </Row>
          </div>
          <div className="pading150 mobileevent">
            <Swiper
              slidesPerView={1.2}
              spaceBetween={10}
              className="swiper-event"
              pagination={{ el: ".swiper-pagination-bullets-event", clickable: true }}
              navigation={{ prevEl: ".arrow-event.first", nextEl: ".arrow-event.last" }}
              modules={[PaginationSwiper, Navigation]}
              onSwiper={(swiper) => {
                swipereventRef.current = swiper;
              }}
            >
              {eventsToRender.map((item, index) => (
                <SwiperSlide>
                  <Card
                    className="eventlist4 is-tappable"
                    onClick={() => {
                      trackEventSelection(item, "event_card_mobile");
                      navigate(`/event/${item._id}`, { state: { name: item.name } });
                    }}
                    >
                    <div className="eventlistimagecontainer">
                      <Card.Img
                        variant="top"
                        className="eventlistimage"
                        src={isMobile ? (item.mobileimage || item.image) : item.image}
                        alt={item.name || "Evento"}
                        width={400}
                        height={216}
                        loading={listImgLoading(index)}
                        decoding="async"
                        fetchPriority={listImgPriority(index)}
                      />
                      <div className="eventlistimageoverlay">{renderPrice(item)}</div>
                      <div className="eventlistimageoverlay2">{dayjs(String(item.startDate || '').slice(0,10)).format("DD MMM, YYYY")}</div>
                    </div>

                    <Card.Body>
                      <Card.Title className="eventlistcardtitle">{item.name}</Card.Title>
                      <div className="event-meta">
                        <div className="meta-pill" style={{ lineHeight: "16px" }}>
                          <svg width="16" height="20" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8 0C3.86 0 .5 3.36.5 7.5c0 1.63.53 3.12 1.42 4.35l5 7.5c.23.35.62.55 1.03.55.41 0 .8-.2 1.02-.55l5-7.5c.89-1.23 1.43-2.72 1.43-4.35C15.5 3.36 12.14 0 8 0Zm0 10A2.5 2.5 0 1 1 8 5a2.5 2.5 0 0 1 0 5Z" fill="#8F99A2"/></svg>
                          <span>{formatVenueCity(item.fulladdress)}</span>
                        </div>
                        <div className="meta-pill">
                          <svg width="18" height="18" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 1a1 1 0 0 1 1 1v1h6V2a1 1 0 1 1 2 0v1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h1V2a1 1 0 1 1 2 0v1ZM3 7v9a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V7H3Z" fill="#8F99A2"/></svg>
                          <span>{dayjs(String(item.startDate || '').slice(0,10)).format("D MMM. - YYYY")}</span>
                        </div>
                        <div className="meta-pill">
                          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 1v22M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" stroke="#8F99A2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
                          <span>{renderPrice(item)}</span>
                        </div>
                      </div>
                      <div className="eventlistcardbutton">
                        <Button
                          className="eventlistbutton"
                          onClick={(e) => {
                            e.stopPropagation();
                            trackEventSelection(item, "event_button_mobile");
                            navigate(`/event/${item._id}`, { state: { name: item.name } });
                          }}
                        >
                          <span class="eventlistbuttontransition"></span>
                          <span class="eventlistbuttonlabel">
                            {item.endDate > dayjs().format("YYYY-MM-DD")
                              ? item.maxbooking > item.totalbooking
                                ? "Obtener entrada"
                                : "Sin entradas"
                              : "Sin entradas"}
                          </span>
                        </Button>
                      </div>
                    </Card.Body>
                  </Card>
                </SwiperSlide>
              ))}
            </Swiper>
            <div className="custom-pagination-event">
              <button className="arrow-event first" onClick={handleFirstClick} style={{ marginRight: "5px" }}>
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M0.219639 6.53021C-0.0732538 6.23732 -0.0732538 5.76244 0.219639 5.46955L4.71964 0.969548C5.01253 0.676655 5.48741 0.676655 5.7803 0.969548C6.07319 1.26244 6.07319 1.73732 5.7803 2.03021L2.56063 5.24988L11.25 5.24988C11.6642 5.24988 12 5.58566 12 5.99988C12 6.41409 11.6642 6.74988 11.25 6.74988L2.56063 6.74988L5.7803 9.96955C6.07319 10.2624 6.07319 10.7373 5.7803 11.0302C5.48741 11.3231 5.01253 11.3231 4.71964 11.0302L0.219639 6.53021Z"
                    fill="#8F99A2"
                  />
                </svg>
              </button>

              <div className="swiper-pagination-bullets-event"></div>

              <button className="arrow-event last" onClick={handleLastClick} style={{ marginLeft: "5px" }}>
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M11.7803 5.46967C12.0732 5.76256 12.0732 6.23744 11.7803 6.53033L7.28033 11.0303C6.98744 11.3232 6.51256 11.3232 6.21967 11.0303C5.92678 10.7374 5.92678 10.2626 6.21967 9.96967L9.43934 6.75L0.75 6.75C0.335787 6.75 0 6.41421 0 6C0 5.58579 0.335787 5.25 0.75 5.25L9.43934 5.25L6.21967 2.03033C5.92678 1.73744 5.92678 1.26256 6.21967 0.96967C6.51256 0.676777 6.98744 0.676777 7.28033 0.96967L11.7803 5.46967Z"
                    fill="#8F99A2"
                  />
                </svg>
              </button>
            </div>
          </div>
          {/* Paginación comentada por solicitud: */}
          {/**
          {pagination.totalPages > 1 && (
            <div className="pagination-bullets-event pading150">
              <Pagination className="pagination-event">
                {pagination.currentPage > 1 && (
                  <Pagination.Prev
                    onClick={() => {
                      filterEvent(selectedFilter, pagination.currentPage - 1);
                      window.scrollTo({ top: 0, behavior: "smooth" });
                    }}
                  />
                )}

                {renderPageNumbers()}
                {pagination.currentPage !== pagination.totalPages && (
                  <Pagination.Next
                    onClick={() => {
                      filterEvent(selectedFilter, pagination.currentPage + 1);
                      window.scrollTo({ top: 0, behavior: "smooth" });
                    }}
                  />
                )}
              </Pagination>
            </div>
          )}
          **/}

          {pagination.currentPage < pagination.totalPages && (
            <div className="pading150" style={{ textAlign: "center", marginRight: 24  }}>
              <Button onClick={loadMore} disabled={isLoadMoreLoading} className="botonEventos">
                {isLoadMoreLoading ? "Cargando..." : "Ver más"}
              </Button>
            </div>
          )}

          {/* Medios de pago (debajo de la paginacion) */}
          <div className="pading150">
            <section className="pay-ways" aria-labelledby="pay-ways-title">
              <h3 id="pay-ways-title" className="pay-ways-title">
              ¿Ya sabés qué evento elegir? Con ZOCO pagalo como quieras             </h3>
              <div className="pay-ways-grid">
                <div
                  className={`pay-card ${openPay.cards ? "open" : ""}`}
                  onClick={() => setOpenPay((p) => (isMobile ? { cards: !p.cards, wallets: false } : { ...p, cards: !p.cards }))}
                  role="button"
                  tabIndex={0}
                >
                  <div className="pay-head">
                     <img src={card} alt="calendario" style={{width: 74, minHeight: 74 }} loading="lazy" decoding="async" />
                    <div className="pay-title">Tarjetas de crédito y débito</div>
                    <div className={`pay-caret ${openPay.cards ? "up" : "down"}`}><img className="arrow" src={cherow} alt="cherow" style={{width: 14, height: 14, marginRight: 15}} /></div>
                  </div>
                  <div className="pay-logos" aria-hidden={!openPay.cards}>
                    <span className="pay-logo"><img src={visa} alt="visa" style={{width: 63 , minHeight: 25 }} loading="lazy" decoding="async" /></span>
                    <span className="pay-logo"><img src={maestro} alt="visa" style={{width: 41 , minHeight: 32 }} loading="lazy" decoding="async" /></span>
                    <span className="pay-logo"><img src={mastercard} alt="visa" style={{width: 41 , minHeight: 32 }} loading="lazy" decoding="async" /></span>
                    <span className="pay-logo"><img src={american} alt="visa" style={{width: 63 , minHeight: 26 }} loading="lazy" decoding="async" /></span>
                    <span className="pay-logo"><img src={argencard} alt="visa" style={{width: 41 , minHeight: 41 }} loading="lazy" decoding="async" /></span>
                    <span className="pay-logo"><img src={dinners} alt="visa" style={{width: 52 , minHeight: 38 }} loading="lazy" decoding="async" /></span>
                    <span className="pay-logo"><img src={cabal} alt="visa" style={{width: 64 , minHeight: 27 }} loading="lazy" decoding="async" /></span>
                  </div>
                </div>

                <div
                  className={`pay-card ${openPay.wallets ? "open" : ""}`}
                  onClick={() => setOpenPay((p) => (isMobile ? { cards: false, wallets: !p.wallets } : { ...p, wallets: !p.wallets }))}
                  role="button"
                  tabIndex={0}
                >
                  <div className="pay-head">
                    <img src={wallet} alt="calendario" style={{width: 70 , minHeight: 70, marginTop: 8 }} loading="lazy" decoding="async" />
                    <div className="pay-title">Billeteras virtuales</div>
                    <div className={`pay-caret ${openPay.wallets ? "up" : "down"}`}><img className="arrow" src={cherow} alt="cherow" style={{width: 14, height: 14, marginRight: 15}} /></div>
                  </div>
                  <div className="pay-logos" aria-hidden={!openPay.wallets}>
                    <div style={{gap: "24px !important", display: "flex", flexWrap: "wrap", justifyContent: "center", marginBottom: 22}}>
                    <span className="pay-logo"><img src={mp} alt="visa" style={{width: 82 , minHeight: 25 }} loading="lazy" decoding="async" /></span>
                    <span className="pay-logo"><img src={bna} alt="visa" style={{width: 69 , minHeight: 25 }} loading="lazy" decoding="async" /></span>
                    <span className="pay-logo"><img src={uala} alt="visa" style={{width: 72 , minHeight: 25 }} loading="lazy" decoding="async" /></span>
                    <span className="pay-logo"><img src={claropay} alt="visa" style={{width: 57 , minHeight: 35 }} loading="lazy" decoding="async" /></span>
                    <span className="pay-logo"><img src={modo} alt="visa" style={{width: 74 , minHeight: 25 }} loading="lazy" decoding="async" /></span>
                    <span className="pay-logo"><img src={naranja} alt="visa" style={{width: 78 , minHeight: 25 }} loading="lazy" decoding="async" /></span>
                    <span className="pay-logo"><img src={personal} alt="visa" style={{width: 79 , minHeight: 25 }} loading="lazy" decoding="async" /></span>
                    <span className="pay-logo"><img src={cuentaDni} alt="visa" style={{width: 65 , minHeight: 25 }} loading="lazy" decoding="async" /></span>
                  </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </>
      ) : !isLoading ? (
        <div className="pading150 no-event-container">
          <img src={not} alt="No se encontraron eventos" className="no-events-found-image" loading="lazy" decoding="async" />
          <div className="no-events-found-text">¡Lo siento! No se encontraron eventos</div>

          {/* SuscripciÃ³n cuando no hay resultados */}
          <div className="subscribe-card" role="region" aria-label="Suscripción a avisos de eventos">
            <div className="subscribe-left">
              <div style={{ display: 'flex', alignItems: 'center', gap: 10 }} className="mvCard">
                {/* Campana */}
                <img src={campana} alt="Campana" style={{ width: 41, minHeight: 41 }} loading="lazy" decoding="async" />
                <div className="subscribe-title">¿No encontraste lo que buscabas?</div>
              </div>
              <div className="subscribe-sub">Suscribite y te avisamos apenas se encuentren disponibles los eventos que más te interesan</div>
            </div>
            <div className="subscribe-divider" aria-hidden="true" />
            <form className="subscribe-form" onSubmit={handleSubscribe} noValidate>
              <input className="subscribe-input" type="email" name="email" placeholder="Email" aria-label="Email" required />
              <button className="subscribe-btn" type="submit">Suscribirse</button>
            </form>
          </div>
        </div>
      ) : null}
      <FloatingAppButton />
    </>
  );
};

export default Event;













